module.exports = __webpack_public_path__ + "static/media/bets_closing.c9e04c22.mp3";